import CommonResult from 'app/components/OrderPayment/Common/CommonResult';
import React from 'react';

const PaypalResultMob = () => {
  return <CommonResult />;
};

export default PaypalResultMob;
